module.exports = __webpack_public_path__ + "static/img/sicbo2_esp.b00bfce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/sicbo2_esp.png
// module id = 9ev2
// module chunks = 1